import { render } from "./singleChatListCard.vue?vue&type=template&id=c7569cb4&scoped=true"
import script from "./singleChatListCard.vue?vue&type=script&lang=js"
export * from "./singleChatListCard.vue?vue&type=script&lang=js"

import "./singleChatListCard.vue?vue&type=style&index=0&id=c7569cb4&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7569cb4"]])

export default __exports__